import { LanguageSelector } from '@gurupay/gp-ui-library';
import { useTranslation } from 'react-i18next';

import { changeAppLanguage, LANGUAGE_OPTIONS } from '../languageOptions';

interface MenuLanguageSelectorProps {
	onLinkClick?: () => void;
}

export const MenuLanguageSelector = ({ onLinkClick }: MenuLanguageSelectorProps) => {
	const { i18n } = useTranslation();

	const changeLanguage = (lng: string) => {
		changeAppLanguage(i18n, lng);
		onLinkClick?.();
	};

	return (
		<LanguageSelector
			onChange={changeLanguage}
			openDirection="top"
			options={LANGUAGE_OPTIONS}
			value={i18n.language}
		/>
	);
};
